module.exports = __webpack_public_path__ + "prod/1.42.2/img/pcBannerBgImg.4307c533.png";